import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatTableDataSource } from "@angular/material";
import "rxjs/add/operator/map";
import { SiteService } from "../../shared/services/site/site.service";
import { ZoneService } from "../../shared/services/zone/zone.service";
import { DeviceService } from "../../shared/services/device/device.service";
import { CommonService } from "../../shared/services";
import { empty } from "rxjs/observable/empty";
import { Observable } from "rxjs/Observable";
import { forEach } from "@angular/router/src/utils/collection";
import { LocationMaster } from "../../shared/interface/location-master";
import {
  Site,
  futureSite,
  OperationalHours,
  DefaultOperationalHours
} from "../../shared/interface/site";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  EventEmitter,
  Inject
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  Validator,
  FormArray
} from "@angular/forms";
import { Country } from "../../shared/interface/country";

@Component({
  selector: "app-sites",
  templateUrl: "./sites.component.html",
  styleUrls: ["./sites.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class SitesComponent implements OnInit {
  dataSource: Site[];

  constructor(public dialog: MatDialog, private deviceService: DeviceService, private siteService: SiteService, private zoneService: ZoneService, private commonService: CommonService) { }

  ngOnInit() {
    this.setList();
    this.siteService.getAction().subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList();
        this.deviceService.sendAction("updateSiteCount", "");
        this.zoneService.sendAction("updateSiteCount", "");
      }
    });
  }

  setList() {
    this.siteService.list().subscribe(
      res => {
        this.dataSource = res;
      },
      err => { }
    );
  }


  gotoDeviceTab(siteId) {
    this.commonService.sendAction("shiftTab", { tab: 'devices' });
    this.deviceService.sendAction("applySiteFilterToDevice", { siteId: siteId });
  }

  openSiteDialog = (data = {}) => {
    this.dialog.open(SiteDialog, {
      data: data,
      height: "auto",
      width: "1024px",
      panelClass: "full-modal"
    });
  };

  public delete(_id) {
    if (
      confirm(
        "Are you sure you want to remove this site. Note: It would remove all devices and zones associated with this site."
      ) == false
    ) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
    this.siteService.delete(_id).subscribe(
      r => {
        this.zoneService.sendAction("siteDelete", "");
        this.deviceService.sendAction("updateSiteCount", "");
      },
      e => {
        this.dataSource = temp;
      }
    );
  }
}

@Component({
  selector: "site-dialog",
  templateUrl: "site.dialog.html"
})
export class SiteDialog {
  siteForm: FormGroup;
  locationMasterList: any;
  isSubmitted: number = 0;  
  minDate = new Date();
  //add more oprational hours
  oHAddCount: number = 1;
  oHMaxCount: number = 3;

  //site opens on day
  openingDays = [];

  //here we can add multiple operational hours
  //created 0th index
  multiOperationalHours = [];

  //full week selected
  multiFullWeek = [];

  //days in week
  week: string[] = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  countryList$: Observable<Country[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private fb: FormBuilder,
    private zoneService: ZoneService,
    public dialogRef: MatDialogRef<SiteDialog>,
    public commonService: CommonService
  ) {
    this.siteService.locationMasterList().subscribe(r => {
      this.locationMasterList = r;
    });
    this.countryList$ = this.siteService.countryList();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setHours(1, 0, 0, 0);    
    data = this.parseData(data);
    this.createForm(data);
  }
  get ScheduledArr() {
    return this.siteForm.get('Scheduled') as FormArray;
  }

  //set default operational array in
  //variable so we can create html using for loop
  setDefaultDataForOperationalHours(k) {
    this.multiOperationalHours[k] = [];
    this.week.forEach((v, i) => {
      this.multiOperationalHours[k].push({
        day: i + 1,
        activeDay: false,
        endOn: "sameDay",
        from: "",// ["", Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")],
        to: "",//["", Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")]
        staffRatio : 0
      });
    });
  }



  parseData(data: any) {

    //creating 1st operational hours
    this.setDefaultDataForOperationalHours(0);


    if (data && data._id) {
      //set location in geo input field
      this.geoSetting["inputString"] = data.location;

      //if it has multiple oprational hours
      if (data.multiOperationalHours.length > 1) {
        this.oHAddCount = data.multiOperationalHours.length;
        data.multiOperationalHours.forEach((oh, k) => {
          this.setDefaultDataForOperationalHours(k);
        });
      }

      // if (data.defaultOperationalHours.from > data.defaultOperationalHours.to) {
      //   data.defaultOperationalHours.endOn = data.defaultOperationalHours.endOn == "nextDay" ? "sameDay" : data.defaultOperationalHours.endOn;

      //   //array of multiple operational hours
      //   if (data.multiOperationalHours && data.multiOperationalHours.length > 0) {
      //     data.multiOperationalHours.forEach((oH, i) => {
      //       oH.forEach((oHDay, j) => {
      //         //set opetainal hours from server data
      //         data.multiOperationalHours[i].forEach(e => {
      //           if (data.multiOperationalHours[i][j].from > data.multiOperationalHours[i][j].to) {
      //             data.multiOperationalHours[i][j].endOn = data.multiOperationalHours[i][j].endOn == "nextDay" ? "sameDay" : data.multiOperationalHours[i][j].endOn
      //           }
      //         });
      //       });
      //     });
      //   }

      //   //   data.operationalHours.forEach((oH, i) => {
      //   //     oH.forEach((oHDay, j) => {
      //   //     //set opetainal hours from server data
      //   //     data.operationalHours[i].forEach(e => {
      //   //       if (oHDay.day == e.day) {
      //   //         data.operationalHours[i][j].endOn = "sameDay";
      //   //       }
      //   //     });
      //   //   });
      //   // });
      // }

      //send validated data
      return data;
    }

    //if creating new record
    return {
      _id: "",
      siteName: "",
      siteTimezone: "",
      countryId: "",
      locationMasterId: "",
      location: "",
      lat: 0,
      lng: 0,
      address: "",
      siteCode: "",
      defaultOperationalHours: {
        from: "",
        endOn: "sameDay",
        to: "",
        staffRatio: 0
      },
      fullWeek: [],
      openingDays: this.openingDays,
      multiOperationalHours: [],
      isActive: "",
      replaceMode: '0',
      replaceDateTime: '',
      Scheduled: this.fb.array([])
    };
  }

  //after data validation
  //prepare form to show in view
  createForm = (data: Site) => {

    this.siteForm = this.fb.group({
      _id: [data._id],
      siteName: [data.siteName, Validators.required],
      locationMasterId: [data.locationMasterId, Validators.required],
      countryId: [data.countryId,Validators.required],
      location: [data.location],
      siteTimezone: [data.siteTimezone, [Validators.pattern("^(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$")]],
      lat: data.lat,
      lng: data.lng,
      address: [data.address, Validators.required],
      siteCode: [data.siteCode],
      defaultOperationalHours: this.fb.group({
        endOn: [data.defaultOperationalHours.endOn, Validators.required],
        from: this.dbTimeToPickerTime(data.defaultOperationalHours.from),
        // [
        //   data.defaultOperationalHours.from,
        //   Validators.compose([
        //     Validators.required,
        //     Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")
        //   ])
        // ],
        to: this.dbTimeToPickerTime(data.defaultOperationalHours.to),
        staffRatio: data.defaultOperationalHours.staffRatio ? data.defaultOperationalHours.staffRatio : 0
        // [
        //   data.defaultOperationalHours.to,
        //   Validators.compose([
        //     Validators.required,
        //     Validators.pattern("^([2][0-4]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$")
        //   ])
        // ]
      }),
      fullWeek: this.fb.array([]),
      openingDays: [data.openingDays],
      multiOperationalHours: this.fb.array([]),
      isActive: data.isActive,
      replaceMode: '0',
      replaceDateTime: '',
      Scheduled: this.fb.array([])
    });
    if (data.Scheduled.length > 0)
      this.setFutureSiteNameFilter(data.Scheduled);
    this.setOperationalHours(data.multiOperationalHours);
  };

  //set data for operational hours
  setOperationalHours(operationalHoursFromData: any = []) {
    let isFullWeek = 0;
    if (operationalHoursFromData.length > 0 && !operationalHoursFromData[0].day) {

      //array of multiple operational hours
      this.multiOperationalHours.forEach((oH, i) => {
        this.multiFullWeek[i] = 0;
        isFullWeek = 0;
        //operational hours
        oH.forEach((oHDay, j) => {

          //set opetainal hours from server data
          operationalHoursFromData[i].forEach(e => {
            if (oHDay.day == e.day) {
              this.multiOperationalHours[i][j].activeDay = (e.isOpen == 0 ? false : true);
              this.multiOperationalHours[i][j].from = this.dbTimeToPickerTime(e.from);
              this.multiOperationalHours[i][j].endOn = e.endOn;
              this.multiOperationalHours[i][j].to = this.dbTimeToPickerTime(e.to);
              this.multiOperationalHours[i][j].staffRatio = e.staffRatio ? e.staffRatio : 0;
              isFullWeek += 1;
            }
          });
        });


        //in UI set full week toggle true
        //if all 7 are selected
        if (isFullWeek == 7) {
          // this.siteForm.get('fullWeek.'+i).setValue(true);
          this.multiFullWeek[i] = 1;
        }


      });
    }

    let multioHFormArray = [];
    //array of multiple operational hours
    this.multiOperationalHours.forEach((oH, i) => {

      //single operational hours
      const oHFGs = oH.map(oHDay => this.fb.group(oHDay));
      const oHFormArray = this.fb.array(oHFGs);
      multioHFormArray.push(oHFormArray);
    });

    //set multiple oprational hours array
    this.siteForm.setControl("multiOperationalHours", this.fb.array(multioHFormArray));
  }


  getAllOperationalHours() {
    return <FormArray>this.siteForm.get('multiOperationalHours');
  }

  getOperationalHours(k) {
    return <FormArray>this.siteForm.get('multiOperationalHours.' + k);
  }

  addMoreOprationalHours() {
    this.setDefaultDataForOperationalHours(this.oHAddCount);
    this.getAllOperationalHours().push(this.fb.array(
      this.multiOperationalHours[this.multiOperationalHours.length - 1].map(oHDay => this.fb.group(oHDay))
    ));
    this.oHAddCount++;
  }

  removeOperationalHours(index) {
    if (confirm("Are you sure you want to remove this operational hours?") == false) {
      return false;
    }
    this.getAllOperationalHours().removeAt(index);
    this.oHAddCount--;
    this.multiFullWeek[index] = (this.multiFullWeek[index + 1] ? this.multiFullWeek[index + 1] : 0)
  }

  selectFullWeek(k) {
    this.multiFullWeek[k] = (this.multiFullWeek[k] ? 0 : 1);
    let value = this.multiFullWeek[k];
    this.week.forEach((v, i) => {
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.activeDay').setValue(value);
      if (value) {
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue(this.siteForm.get('defaultOperationalHours.from').value);
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue(this.siteForm.get('defaultOperationalHours.endOn').value);
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue(this.siteForm.get('defaultOperationalHours.to').value);
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.staffRatio').setValue(this.siteForm.get('defaultOperationalHours.staffRatio').value);
      } else {
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue("");
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue("");
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue("");
        this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.staffRatio').setValue(0);
      }
    })
  }

  dbTimeToPickerTime(time) {
    let dateToday = new Date();
    let timeArray = time.split(':');
    let datt = new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate(), timeArray[0], timeArray[1], timeArray[2]);
    let convertedDate = this.commonService.getDateConverted(datt, "YYYY-MM-DD HH:mm:ss");
    // let convertedDate = this.commonService.getOffsetConvertedSite(datt, "YYYY-MM-DD HH:mm:ss", true);
    return new Date(convertedDate);
  }

  pickerTimeToDBTime(pDate) {
    let dtf = pDate;
    let convertedDate = new Date(this.commonService.getDateConverted(dtf, "YYYY-MM-DD HH:mm:ss"));
    // let convertedDate = new Date(this.commonService.getOffsetConvertedSite(dtf, "YYYY-MM-DD HH:mm:ss", false));
    let sdf2 = this.addZero(convertedDate.getHours()) + ':' + this.addZero(convertedDate.getMinutes()) + ':' + this.addZero(convertedDate.getSeconds());
    return sdf2;
    // return this.addZero(new Date(dtf).getHours()) + ':' + this.addZero(new Date(dtf).getMinutes()) + ':' + this.addZero(new Date(dtf).getSeconds());
  }


  autoCompleteLocation(selectedData: any) {
    if (selectedData && selectedData.data) {
      this.siteForm.patchValue({
        location: selectedData.data.formatted_address,
        lat: selectedData.data.geometry.location.lat,
        lng: selectedData.data.geometry.location.lng
      });
    } else {
      this.siteForm.patchValue({
        location: "",
        lat: "",
        lng: ""
      });
    }
  }

  geoSetting: any = {
    showSearchButton: false,
    inputPlaceholderText: "Override above location master",
    showCurrentLocation: false
  };

  //set operational hours to default on active
  setOhValue(value, k, i) {
    if (value) {
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue(this.siteForm.get('defaultOperationalHours.from').value);
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue(this.siteForm.get('defaultOperationalHours.endOn').value);
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue(this.siteForm.get('defaultOperationalHours.to').value);
    } else {
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.from').setValue("");
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.endOn').setValue("");
      this.siteForm.get('multiOperationalHours.' + k + '.' + i + '.to').setValue("");
    }
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  blockInput($event) {
    $event.preventDefault();
  }


  onSubmit(f: any) {
    let form = Object.assign({}, f);

    if (!this.siteForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    //get lat lng from location master if location not set
    if (form.location == "") {
      this.locationMasterList.forEach(lm => {
        if (lm._id == form.locationMasterId) {
          form.lat = lm.lat;
          form.lng = lm.lng;
        }
      });
    }

    let tempOperationDays = [];
    let tempOperationHrs = [];

    //create array for opening days
    form.multiOperationalHours.forEach((oH, i) => {
      oH.forEach((v) => {
        if (v.activeDay) {
          tempOperationDays.push(v.day);
        }
      });
    });
    form.openingDays = tempOperationDays;

    let from = this.pickerTimeToDBTime(form.defaultOperationalHours.from);
    let tempF = from.split(':');

    let to = this.pickerTimeToDBTime(form.defaultOperationalHours.to);
    let tempT = to.split(':');

    form.defaultOperationalHours.from = `${tempF[0]}:${tempF[1]}:00`;
    form.defaultOperationalHours.to = `${tempT[0]}:${tempT[1]}:59`;


    //Since we are converting to UTC check for next day concept
    if (from > to)
      form.defaultOperationalHours.endOn = form.defaultOperationalHours.endOn == "sameDay" ? "nextDay" : form.defaultOperationalHours.endOn;

    //modify array for operational days to set default days and time
    form.multiOperationalHours.forEach((oH, k) => {
      tempOperationHrs[k] = [];

      let from, to, tempF, tempT;
      oH.forEach((v, i) => {
        if (v.activeDay) {
          if (v.from == "" || v.to == "") {
            from = this.pickerTimeToDBTime(form.defaultOperationalHours.from);
            tempF = from.split(':');
            to = this.pickerTimeToDBTime(form.defaultOperationalHours.to);
            tempT = to.split(':');

            if (from > to)
              form.defaultOperationalHours.endOn = form.defaultOperationalHours.endOn == "sameDay" ? "nextDay" : form.defaultOperationalHours.endOn;



            v.endOn = form.defaultOperationalHours.endOn;
            v.from = `${tempF[0]}:${tempF[1]}:00`;
            v.to = `${tempT[0]}:${tempT[1]}:59`;
          } else {
            from = this.pickerTimeToDBTime(v.from);
            tempF = from.split(':');

            to = this.pickerTimeToDBTime(v.to);
            tempT = to.split(':');

            if (from > to)
              oH[i].endOn = oH[i].endOn == "sameDay" ? "nextDay" : oH[i].endOn;

            v.from = `${tempF[0]}:${tempF[1]}:00`;
            v.to = `${tempT[0]}:${tempT[1]}:59`;
          }
          tempOperationHrs[k].push(oH[i]);
        }
      });
    });
    form.operationalHours = tempOperationHrs;




    //modify isActive value from boolean to 0/1
    if (form.isActive) {
      form.isActive = 1;
    } else {
      form.isActive = 0;
    }

    // create site
    if (form._id == "") {
      form["future"] = false;
      this.siteService.create(form).subscribe(
        res => {
          this.dialogRef.close();
          this.siteService.sendAction("create", "");
          this.zoneService.sendAction("siteCreate", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      if (confirm(
        "Do you want to override the current name?") == false) {
        this.isSubmitted = 0;
        return false;
      }
      // Update site
      form.siteId = form._id;
      form["future"] = this.commonService.inFuture(form.replaceDateTime);
      if (form.replaceDateTime)
        form.replaceDateTime = form.replaceDateTime;
      this.siteService.update(form).subscribe(
        res => {
          this.dialogRef.close();
          this.siteService.sendAction("update", "");
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }

  gridDate = (value: any) => {
    let d = new Date(value);
    let u =
      d.getFullYear() +
      "-" +
      this.addZero(d.getMonth() + 1) +
      "-" +
      this.addZero(d.getDate()) +
      "T" +
      this.addZero(d.getHours()) +
      ":" +
      this.addZero(d.getMinutes())

    return u;
  }

  edit = (i: number) => {
    for (let j = 0; j < this.ScheduledArr.length; j++) {
      let editItem = this.ScheduledArr.at(j) as FormArray;
      editItem.controls["edit"].value = (i === j ? true : false);
      this.ScheduledArr.at(j).patchValue(editItem);
    }
  }

  cancel = (id: string) => {
    this.siteService.scheduledSiteList(id).subscribe(
      res => {
        this.setFutureSiteNameFilter(res);
      })
  }

  delete = (id: string, i: number) => {
    if (confirm("Are you sure you want to remove this?") == false) {
      return false;
    }
    this.siteService.deleteFutureSite(id).subscribe(
      r => {
        this.ScheduledArr.removeAt(i);
        this.siteService.sendAction("update", "");
      },
      e => { }
    );
  }

  update = (data: {}, i: number) => {
    let date = data["scheduledDate"];
    data["replaceDateTime"] = date;
    data["future"] = this.commonService.inFuture(data["scheduledDate"]);
    if (data["future"]) {
      this.siteService.updateFutureSite(data).subscribe(
        res => {
          this.siteService.scheduledSiteList(data["siteId"]).subscribe(
            res => {
              this.setFutureSiteNameFilter(res);
            });
          this.siteService.sendAction("update", "");
        },
        err => {
        }
      );
    }
    else {
      this.siteService.scheduledSiteList(data["siteId"]).subscribe(
        res => {
          this.setFutureSiteNameFilter(res);
        })
      let editItem = this.ScheduledArr.at(i) as FormArray;
      editItem.controls["edit"].value = true;
      this.ScheduledArr.at(i).patchValue(editItem);
      this.commonService.openSnackBar("Only future dates are allowed", "");
    }
  }

  setFutureSiteNameFilter(futureSite: any = []) {
    const futureSiteFormGroups = futureSite.map((fields, i) => {
      const gorup = this.fb.group({
        _id: fields._id,
        siteName: [fields.siteName, Validators.required],
        siteId: fields.siteId,
        scheduledDate: fields.scheduledDate,
        edit: false
      })
      return gorup;
    });
    const FilterFormArray = this.fb.array(futureSiteFormGroups);
    this.siteForm.setControl("Scheduled", FilterFormArray);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/sites/sites.component.ts